export let optionTitle_quickSteps = "_dD43d";
export let optionSearch_quickSteps = "QBFlE";
export default {optionTitle_quickSteps,optionSearch_quickSteps};